export default __webpack_public_path__ + "static/media/grafema_amcc_02.2905d761.jpg";